import React, { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import { Card, Col, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import SeccionDatosCliente from '../SeccionDatosCliente';
import SeccionDatosLicencia from '../SeccionDatosLicencia';
import SeccionHarwareLicencia from '../SeccionHardwareLicencia';
import SeccionVinculacionAkasiaPOS from './SeccionVinculacionAkasiaPOS';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import GoogleMap from 'akasia-components/licencia/DetallesLicencia/map/GoogleMap';

const SeccionPrincipalDatos = ({
    idLicencia,
    licencias,

    setProcesandoModal,
    procesandoModal,
    editar,
    setEditar,

    getInformacionDetalladaLicenciaByID,

    setPolizasRelacionadas,

    akasiaPOSWebPaquetes,

    infoSuscripcion,
    cargando

}) => {

    const [tipoLicencia, setTipoLicencia] = useState([]);
    const [usuariosNube, setUsuariosNube] = useState([]);
    const [cicloFacturacion, setCicloFacturacion] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [datosPCLogin, setDatosPCLogin] = useState([]);
    const [jsonFile, setJsonFile] = useState(null);
    const [linkageStatus, setLinkageStatus] = useState(null);
    const [loadingLinkageStatus, setLoadingLinkageStatus] = useState(false);

    const { token } = useToken();
    const { showErrorToast, showInfoToast } = useToast();

    /**
     * Obtiene los datos básicos de la licencia
     */
    const getDatosBasicosLicencia = async () => {
        try {
            // setCargando(true);
            const response = await fetch(`/api/licencia/ObtenerSeccionDatosLicencia/?id=${idLicencia}`, {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            //console.log(data, "DATA SECCION")


            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("Seccion Datos Principal", ObjDetalles)


                // Actualizar el estado con los datos obtenidos
                setTipoLicencia(ObjDetalles.table2);
                setCicloFacturacion(ObjDetalles.table3);
                setVendedores(ObjDetalles.table4);
                setDatosPCLogin(ObjDetalles.table5);
            }

        } catch (error) {
            showErrorToast(error.message);
            console.error('Error al obtener datos de la licencia:', error);
        } finally {
            //setCargando(false);
        }
    };

    const checkLinkageStatus = async () => {
        try {
            setLoadingLinkageStatus(true);

            const response = await fetch('/api/licencia/CheckLinkageStatus', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idLicenciaNube: idLicencia })
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Linkage status:', data);

                if (data.iResponseType === 1 && data.detalles) {
                    const statusArray = JSON.parse(data.detalles);
                    if (Array.isArray(statusArray) && statusArray.length > 0) {
                        setLinkageStatus(statusArray[0]);
                    }
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.error('Error checking linkage status:', error);
        } finally {
            setLoadingLinkageStatus(false);
        }
    };

    // Cargar datos al montar el componente
    useEffect(() => {
        getDatosBasicosLicencia();
        console.log("licencias", licencias)
        // Verificar estado de vinculación si es licencia tipo 3 o 7
        if (licencias.idCatTipoLicencia === 3 || licencias.idCatTipoLicencia === 7) {
            console.log("Entrando a checkLinkageStatus para tipo:", licencias.idCatTipoLicencia);
            checkLinkageStatus();
        }
    }, [idLicencia, licencias]);

    const generarVinculacion = async () => {
        try {
            setProcesandoModal(true);

            const response = await fetch('/api/licencia/GenerateLinkageData', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ vLicenseLink: idLicencia })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            console.log('Linkage data generated:', data);

            if (data.iResponseType === 1) {
                // Descargar el archivo JSON con los detalles
                if (data.detalles) {
                    const detallesData = JSON.parse(data.detalles);
                    const jsonString = JSON.stringify(detallesData, null, 2);
                    const blob = new Blob([jsonString], { type: 'application/json' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `vinculacion_${idLicencia}.json`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
                showInfoToast('Vinculación generada exitosamente');
            } else {
                showErrorToast(data.vMessage || 'Error al generar vinculación');
            }
        } catch (error) {
            showErrorToast(error.message);
            console.error('Error generating linkage:', error);
        } finally {
            setProcesandoModal(false);
        }
    };

    const autoLinkLicenses = async () => {
        try {
            if (!jsonFile) {
                showErrorToast('Por favor selecciona un archivo JSON');
                return;
            }

            setProcesandoModal(true);

            // Leer el archivo JSON
            const fileContent = await jsonFile.text();
            const jsonData = JSON.parse(fileContent);

            if (!Array.isArray(jsonData) || jsonData.length === 0) {
                showErrorToast('El archivo JSON debe contener un array con datos');
                return;
            }

            // Obtener el primer elemento del array
            const linkData = jsonData[0];
            const idLicenciaPOSWeb = linkData.idLicenciaPOSWeb;
            const vBDPOSWeb = linkData.vBDPOSWeb;

            const response = await fetch('/api/licencia/AutoLinkLicenses', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idLicenciaNube: parseInt(idLicencia),
                    idLicenciaPOSWeb: idLicenciaPOSWeb,
                    vBDPOSWeb: vBDPOSWeb
                })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            console.log('AutoLink response:', data);

            if (data.iResponseType === 1) {
                showInfoToast('Vinculación automática completada exitosamente');
                setJsonFile(null);
                // Recargar estado de vinculación
                checkLinkageStatus();
            } else if (data.vMessage === 'POSWebLicenseAlreadyExists') {
                const idConflicto = data.detalles?.idLicenciaConflicto;
                const nombreConflicto = data.detalles?.vNombreEmpresaConflicto;
                const detalle = idConflicto
                    ? `Ya está vinculada a la licencia #${idConflicto}${nombreConflicto ? ` (${nombreConflicto})` : ''}`
                    : 'Esta empresa ya tiene una Nube vinculada';
                showErrorToast(`Esta empresa ya fue vinculada a una Nube Akasia. ${detalle}`);
            } else {
                showErrorToast(data.vMessage || data.vCode || 'Error al vincular licencias');
            }
        } catch (error) {
            showErrorToast(error.message);
            console.error('Error in autoLinkLicenses:', error);
        } finally {
            setProcesandoModal(false);
        }
    };

    const isNube = licencias.idCatTipoLicencia == 3;

    const isPOSWeb = licencias.idCatTipoLicencia == 7;
    const hasMapa = !isNube && !!(licencias.vLatLon || licencias.vLatLonSistema);
    const hasUltimosInicios = !isNube && !isPOSWeb && datosPCLogin && datosPCLogin.length > 0;
    const hasRightSide = hasUltimosInicios || hasMapa;

    const seccionClienteComp = (
        <SeccionDatosCliente
            licencias={licencias}
            idLicencia={idLicencia}
            getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}
            usuariosNube={usuariosNube}
            setUsuariosNube={setUsuariosNube}
            infoSuscripcion={infoSuscripcion}
        />
    );

    const seccionLicenciaComp = (
        <SeccionDatosLicencia
            idLicencia={idLicencia}
            licencias={licencias}
            setProcesandoModal={setProcesandoModal}
            procesandoModal={procesandoModal}
            editar={editar}
            setEditar={setEditar}
            getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}
            vendedores={vendedores}
            tipoLicencia={tipoLicencia}
            cicloFacturacion={cicloFacturacion}
            setPolizasRelacionadas={setPolizasRelacionadas}
            usuariosNube={usuariosNube}
            setUsuariosNube={setUsuariosNube}
            akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}
            infoSuscripcion={infoSuscripcion}
        />
    );

    const vinculacionNubeComp = licencias.idCatTipoLicencia === 3 && (
        <Card className="fs--1 mt-3 mb-3">
            <Card.Header>
                <h5>Vinculaci&oacute;n de Akasia POS Web a Nube</h5>
            </Card.Header>
            <Card.Body className="border-top">
                {loadingLinkageStatus ? (
                    <div className="text-center py-3">
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                ) : linkageStatus?.bIsLinked ? (
                    <div>
                        <div className="alert alert-success mb-3">
                            <strong>Estado:</strong> {linkageStatus.vEstadoVinculacion}
                        </div>
                        <p className="mb-2"><strong>Mensaje:</strong> {linkageStatus.vMensaje}</p>
                        <p className="mb-2"><strong>ID Cliente Akasia:</strong> {linkageStatus.idClienteAkasia}</p>
                    </div>
                ) : (
                    <Row className="g-3">
                        <Col xs={12}>
                            <p className="mb-3 text-muted">
                                Al vincular, los datos de la licencia POS Web se sincronizar&aacute;n con esta licencia Nube en su Akasia Desktop.
                            </p>
                            <label className="form-label">Archivo JSON de Vinculaci&oacute;n</label>
                            <input
                                type="file"
                                className="form-control"
                                accept=".json"
                                onChange={(e) => setJsonFile(e.target.files[0])}
                                disabled={procesandoModal}
                            />
                            {jsonFile && (
                                <small className="text-muted d-block mt-1">
                                    Archivo seleccionado: {jsonFile.name}
                                </small>
                            )}
                        </Col>
                        <Col xs={12}>
                            <button
                                className="btn btn-success w-100"
                                onClick={autoLinkLicenses}
                                disabled={procesandoModal || !jsonFile}
                            >
                                {procesandoModal ? 'Procesando...' : 'Vincular Licencias'}
                            </button>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );

    const dashboardMigracionComp = (
        <SeccionVinculacionAkasiaPOS
            idLicencia={idLicencia}
            licencias={licencias}
            getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}
        />
    );

    const vinculacionPOSComp = licencias.idCatTipoLicencia === 7 && (
        <Card className="fs--1 mb-3">
            <Card.Header>
                <h5>Vinculaci&oacute;n de AkasiaPos</h5>
            </Card.Header>
            <Card.Body className="border-top">
                {loadingLinkageStatus ? (
                    <div className="text-center py-3">
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                ) : linkageStatus?.bIsLinked ? (
                    <div>
                        <div className="alert alert-success mb-3">
                            <strong>Estado:</strong> {linkageStatus.vEstadoVinculacion}
                        </div>
                        <p className="mb-2"><strong>Mensaje:</strong> {linkageStatus.vMensaje}</p>
                        <p className="mb-3"><strong>ID Cliente Akasia:</strong> {linkageStatus.idClienteAkasia}</p>
                    </div>
                ) : (
                    <Row className="g-3">
                        <Col xs={12}>
                            <button
                                className="btn btn-primary w-100"
                                onClick={generarVinculacion}
                                disabled={procesandoModal}
                            >
                                {procesandoModal ? 'Procesando...' : 'Generar Vinculaci\u00f3n'}
                            </button>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );

    return (
        <>
            {!hasRightSide ? (
                <Row className="g-3 mb-3">
                    <Col lg={6}>
                        {seccionClienteComp}
                    </Col>
                    <Col lg={6}>
                        {seccionLicenciaComp}
                        {!isNube && !isPOSWeb && (
                            <div className="mt-3">
                                <SeccionHarwareLicencia
                                    idLicencia={idLicencia}
                                    setMensajeError={() => { }}
                                    setShowMensajeError={() => { }}
                                />
                            </div>
                        )}
                        {vinculacionNubeComp}
                        {dashboardMigracionComp}
                        {vinculacionPOSComp}
                    </Col>
                </Row>
            ) : (
                <Row className="g-3 mb-3">
                    <Col lg={6} className="d-flex flex-column gap-3">
                        {seccionClienteComp}
                        <div className="flex-grow-1">
                            {seccionLicenciaComp}
                        </div>
                    </Col>
                    <Col lg={6} className="d-flex flex-column">
                        {hasUltimosInicios &&
                            <Card className="fs--1 mb-3">
                                <Card.Header className="py-2">
                                    <h5>&Uacute;ltimos inicios de sesi&oacute;n</h5>
                                </Card.Header>
                                <Card.Body className="border-top p-0">
                                    {datosPCLogin.map((log, index) => (
                                        <div key={index} className="d-flex flex-wrap align-items-center justify-content-between border-bottom px-3 py-2" style={{ gap: '0.5rem' }}>
                                            <div className="d-flex align-items-center flex-wrap" style={{ gap: '0.75rem' }}>
                                                <span className={classNames('badge rounded-pill', 'badge-soft-success')}>
                                                    {log.vIpPublica}
                                                </span>
                                                <span className="fw-semi-bold text-dark">{log.vMachineName}</span>
                                                <code>{log.vVersion}</code>
                                            </div>
                                            <div className="d-flex align-items-center flex-wrap" style={{ gap: '0.5rem' }}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip style={{ position: 'fixed' }}><strong>{log.vDatosPcLogIn}</strong></Tooltip>}
                                                >
                                                    <img src="/img/pcautorizada25.png" alt="PC Autorizada" style={{ cursor: 'pointer' }} />
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip style={{ position: 'fixed' }}><strong>{log.vConectionString}</strong></Tooltip>}
                                                >
                                                    <img src="/img/servidor25.png" alt="Servidor" style={{ cursor: 'pointer' }} />
                                                </OverlayTrigger>
                                                {log.vLatLonSistema && (
                                                     <OverlayTrigger
                                                         placement="top"
                                                         overlay={<Tooltip style={{ position: 'fixed' }}><strong>{log.vLatLonSistema}</strong></Tooltip>}
                                                     >
                                                         <a href={"https://www.google.com/maps/place/" + log.vLatLonSistema} target="_blank" rel="noreferrer">
                                                             <img src="/img/ubicacion25.png" alt="Ubicación" />
                                                         </a>
                                                     </OverlayTrigger>
                                                 )}
                                                 <span className="text-muted ms-1" style={{ fontSize: '0.8rem' }}>
                                                     {log.dCreatedDate}
                                                 </span>
                                             </div>
                                         </div>
                                     ))}
                                 </Card.Body>
                             </Card>
                         }

                         {!isNube && !isPOSWeb &&
                             <SeccionHarwareLicencia
                                 idLicencia={idLicencia}
                                 setMensajeError={() => { }}
                                 setShowMensajeError={() => { }}
                             />
                         }

                         {vinculacionPOSComp}

                         {hasMapa && (
                             <Card className="flex-grow-1 d-flex flex-column">
                                 <Card.Header>
                                     <h5 className="mb-0">Mapa -Ubicaci&oacute;n de la licencia</h5>
                                 </Card.Header>
                                 <Card.Body className="border-top p-0 flex-grow-1 position-relative" style={{ minHeight: '350px' }}>
                                     {cargando ? (
                                         <h3 className="p-3">
                                             <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                                         </h3>
                                     ) : (
                                         (() => {
                                             const coordenadas = licencias.vLatLon || licencias.vLatLonSistema;
                                             return (
                                                 <div className="position-absolute top-0 start-0 w-100 h-100">
                                                     <GoogleMap
                                                         initialCenter={{
                                                             lat: parseFloat(coordenadas.split(',')[0]),
                                                             lng: parseFloat(coordenadas.split(',')[1])
                                                         }}
                                                         mapStyle="Default"
                                                         darkStyle="Default"
                                                     >
                                                         <p className="fs--1 mb-0">
                                                             {coordenadas}
                                                         </p>
                                                     </GoogleMap>
                                                 </div>
                                             );
                                         })()
                                     )}
                                 </Card.Body>
                             </Card>
                         )}
                     </Col>
                 </Row>
             )}

        </>
    );
};

SeccionPrincipalDatos.propTypes = {
    idLicencia: PropTypes.string.isRequired,
    licencias: PropTypes.object.isRequired,

    setProcesandoModal: PropTypes.func.isRequired,
    procesandoModal: PropTypes.bool.isRequired,
    editar: PropTypes.bool.isRequired,
    setEditar: PropTypes.func.isRequired,

    getInformacionDetalladaLicenciaByID: PropTypes.func.isRequired,

    setPolizasRelacionadas: PropTypes.func.isRequired,

    akasiaPOSWebPaquetes: PropTypes.array.isRequired,

    infoSuscripcion: PropTypes.object,
    cargando: PropTypes.bool
};

export default SeccionPrincipalDatos;
